export const PROVINCES_BY_COUNTRY = {
  'Australia': [],
  'Brazil': [],
  'Canada': ['alberta', 'quebec', 'ontario'],
  'China': ['peoplesrepublicofchina'],
  'Denmark': [],
  'Finland': [],
  'France': ['seine-saint-denis'],
  'Germany': ['germany(aldisüd)'],
  'Hong Kong': [],
  'India': [],
  'Italy': [],
  'Ireland': [],
  'Japan': [],
  'Russia': [],
  'Saudi Arabia': [],
  'South Korea': [],
  'Sweden': [],
  'Switzerland': [],
  'Turkey': [],
  'United Kingdom': ['uk', 'england', 'scotland', 'london'],
  'United States': [
    'California',
    'colorado',
    'nebraska',
    'newjersey',
    'newyork',
    'newyorkcity',
    'ny',
    'nyus',
    'pennsylvania',
    'texas',
    'us',
    'usa',
    'utah(allybank)',
  ],
  'Venezuela': [],
}

export const PROVINCES = Object.values(PROVINCES_BY_COUNTRY).reduce((acc: string[], cities: string[]) => acc.concat(cities), [])

export const CITIES_BY_COUNTRY = {
  'United States': [
    'Fremont',
    'Oakland',
    'San Francisco',
    'Berkeley',
    'Nevada',
    'Sacramento',
    'San Mateo',
    'Redwood City',
    'Brooklyn',
  ],
}

export const STREETS_NAMES = [
  'Ocean Ave',
  'Golden Gate',
  'Whitfield Court',
  'Avenue',
  'Diamond Heights',
  'Broadway',
  'Embarcadero',
  'Clementina',
  'City Hall',
]
